import validate from "/workspace/node_modules/.pnpm/nuxt@3.11.2_@parcel+watcher@2.4.1_@types+node@20.11.19_@unocss+reset@0.60.3_encoding@0.1.13_e_pt6mcsv5xdz3ixglsdisjmax5e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/workspace/node_modules/.pnpm/nuxt@3.11.2_@parcel+watcher@2.4.1_@types+node@20.11.19_@unocss+reset@0.60.3_encoding@0.1.13_e_pt6mcsv5xdz3ixglsdisjmax5e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}